/* @flow */

import glamorous from 'glamorous';

const NavBarFlat = glamorous.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  overflow: 'auto',
}));

export default NavBarFlat;
